/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionresumed1Inputs */

const en_subscriptionresumed1 = /** @type {(inputs: Subscriptionresumed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription has been resumed.`)
};

const de_subscriptionresumed1 = /** @type {(inputs: Subscriptionresumed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Abonnement wurde fortgesetzt.`)
};

/**
* | output |
* | --- |
* | "Your subscription has been resumed." |
*
* @param {Subscriptionresumed1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const subscriptionresumed1 = /** @type {((inputs?: Subscriptionresumed1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionresumed1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscriptionresumed1(inputs)
	return de_subscriptionresumed1(inputs)
});
export { subscriptionresumed1 as "subscriptionResumed" }